import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import { AdminModule } from '../..';
import { Page } from '../../../../components/page/Page';
import { IfAnyVideoStation } from '../../../../components/stations/IfAnyVideoStation';
import { VideoAnalysisForm } from './VideoAnalysisForm';
export function AdminVideoAnalysisPage() {
  const title = 'Video Analysis config';

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<PersonalVideoIcon />}
        title={title}
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <IfAnyVideoStation>
          <VideoAnalysisForm />
        </IfAnyVideoStation>
      </Page.Content>
    </Page>
  );
}
